<template>
  <v-chip :color="getTypeColor(status.name)" text-color="white" label>
    {{ status.text }}
  </v-chip>
</template>

<script>
export default {
  name: 'CustomerDocumentStatus',
  props: {
    status: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getTypeColor(name) {
      let color = 'default'

      switch (name) {
        case 'CONFIRMED':
          color = '#4caf50'
          break

        case 'PENDING':
          color = '#ff9800'
          break

        case 'REJECTED':
          color = '#f44336'
          break

        default:
          color = 'default'
      }

      return color
    },
  },
}
</script>
